import { defineFcm } from '../shared/factory';

export const FCM_GOOGLE_AUTH_USE_IDENTITY_SERVICES = defineFcm('google_auth_use_identity_services')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'TBD',
		context: 'Login / Sign up',
		description: `If true, Google Authentication will use Google Identity Services (GIS) which is the new way of doing Google Auth (the old API being deleted end of March 2023).

		This is a temporary flag to be able to flip a switch if a bug is found in the new implementation. This flag should be removed (along with the old Google Auth code) once the old Google API is deleted.

		Related to "google_auth" FCM.`,
		import: false,
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
